// Geological unit colors matching the legacy system
export const GEOLOGICAL_UNIT_COLORS = {
  "Del Rio, Georgetown, Main Street & Paw Paw Limestone": "#E8BA6C",
  "Glen Rose": "#99DEF5",
  "Austin Chalk": "#94CE94",
  "Midway and Taylor Groups, Austin Chalk": "#94CE94",
  "Pearsall & Hammett Shale": "#DFE094",
  "Sligo & Hosston": "#403ECD",
  Hosston: "#403ECD",
  Walnut: "#097608",
  "Edwards and Associated Limestone Formations ": "#C5FBC7",
  "Edwards & Commanche Peak Limestone": "#C5FBC7",
  "Hensell & Cow Creek Limestone": "#C454C4",
  "Wilcox Formation": "#D2B48C",
};

// Virtual bore URL parameter keys
export const VB_URL_PARAMS = {
  LAT: "vb_lat",
  LON: "vb_lon",
};

// Custom event names
export const VIRTUAL_BORE_EVENTS = {
  URL_PARAMS_CHANGED: "virtualBoreUrlParamsChanged",
};

// API endpoint - use the combined endpoint for simplicity
export const API_ENDPOINT = "/api/public-map/virtual-bore/coordinates";
